import { useUserAuthrity } from "./useUserAuthrity"


export const useUserRoutes = () => {
    const { data, refetch } = useUserAuthrity()

    const routers = data?.routers || []

    return {
        routers,
        refetch
    }
}
